import * as Raven from 'raven-js';
import * as ko from 'knockout';
import 'core-js/client/shim.min';
import 'zone.js';
import 'reflect-metadata';
import 'autotrack';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {enableProdMode} from '@angular/core';
import {UserPageModule} from './user-page-module';
import {CurrencyCalculatorComponent} from './../app-pages/currency/currency-calculator';
import {CurrencyRatesComponent} from './../app-pages/currency/currency-rates';
import {TranslateComponent} from './../app-pages/common/translate';
import {init} from './../app-pages/knockout-extensions';
import {CurrencyChartComponent} from "../app-pages/currency/currency-chart";
import {NbpCurrencyRateComponent} from "../app-pages/currency/nbp-currency-rate";
import "jquery-validation";
import "jquery-form";
import "hammerjs"
import "knockout-mapping";
import "chart.js";

init();

ko.components.register('dk-k-currency-calculator', {
    viewModel: CurrencyCalculatorComponent,
    template: require('./../app-pages/currency/currency-calculator.html')
});

ko.components.register('dk-k-currency-rates-column', {
    viewModel: CurrencyRatesComponent,
    template: require('./../app-pages/currency/currency-rates-column.html')
});

ko.components.register('dk-k-currency-rates-table-only', {
    viewModel: CurrencyRatesComponent,
    template: require('./../app-pages/currency/currency-rates-table-only.html')
});

ko.components.register('dk-t', {
    viewModel: TranslateComponent,
    template: require('./../app-pages/common/translate.html')
});

ko.components.register('dk-nbp-currency-rate', {
    viewModel: NbpCurrencyRateComponent,
    template: require('./../app-pages/currency/nbp-currency-rate.html')
});

ko.components.register('dk-currency-chart', {
    viewModel: CurrencyChartComponent,
    template: require('./../app-pages/currency/currency-chart.html')
});

declare var DKPROD: boolean;
declare var GOOGLEANALYTICSID: string;
declare var ga: any;

if (DKPROD) {
    Raven.config('https://b95425c8c70549feaf9072e315f2357d@sentry.io/127528').install();
}

window['ga']=window['ga'] || function(){(ga.q=ga.q||[]).push(arguments)};
ga.l=+new Date;
ga('create', GOOGLEANALYTICSID, 'auto');

// Replace the following lines with the plugins you want to use.
ga('require', 'eventTracker');
ga('require', 'outboundLinkTracker');
ga('require', 'urlChangeTracker');

ga('send', 'pageview');

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}

enableProdMode();
platformBrowserDynamic().bootstrapModule(UserPageModule);



